/**
 * Vuex getters for the "posts" (feed) module.
 *
 * Thin state accessors exposing the draft-post state as-is.
 */
export default {
  getDraftPosts: state => state.draftPosts,
  getDataDraftPost: state => state.draftDataPost,
};
